// @flow @jsx h

import { h, Component } from 'preact'
import { bem } from '@nrk/dh-utils'

import { TIERS } from '../../constants/'
import { imagePaths } from '../../config/images'

import styles from './Whale.css'

type State = {}

type Props = {
  currentTier: number,
  children: any
}

const { TIER_ONE, TIER_TWO, TIER_THREE, TIER_FOUR, TIER_FIVE, TIER_SIX } = TIERS

class Whale extends Component<Props, State> {
  render() {
    const { currentTier } = this.props
    const modifiers = {
      dead: currentTier === TIER_ONE,
      'extra-sad': currentTier === TIER_TWO,
      sad: currentTier === TIER_THREE,
      happy: currentTier === TIER_FOUR,
      'extra-happy': currentTier === TIER_FIVE,
      saved: currentTier === TIER_SIX
    }

    return (
      <div class={bem(styles.whale__wrapper)}>
        <div class={bem(styles['whale__swim-wrapper'], modifiers)}>
          {this.props.children}
          <div class={bem(styles.whale)}>
            <img
              alt=''
              src={imagePaths[currentTier]}
              class={bem(styles.whale__image)}
            />
          </div>
        </div>
      </div>
    )
  }
}

export { Whale }



// WEBPACK FOOTER //
// ./src/v1/components/Background/Whale.js